import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { navigateTo } from 'gatsby-link';
import Media from 'react-media';

import './BlogPostCard.scss';

const BlogPostCard = props => {
  const blogPost = props.blogPost.node;
  const transformedPost =
    blogPost.childContentfulBlogPostPostTextNode.childMarkdownRemark;
  const heroPhoto = blogPost.heroPhoto;
  const date = blogPost.date;
  const excerpt = transformedPost.excerpt;
  const timeToRead = transformedPost.timeToRead;

  return (
    <div
      onClick={() =>
        navigateTo(`/${blogPost.node_locale}/blog/${blogPost.slug}`)
      }
      className="blog-post-card"
    >
      <Media query={{ minWidth: '768px' }}>
        {matches =>
          matches ? (
            // si plus grand que 768px =>
            <Img
              className="blog-post-card-img"
              alt={heroPhoto.title}
              sizes={{ ...heroPhoto.sizes, aspectRatio: 930 / 300 }}
            />
          ) : (
            <Img
              className="blog-post-card-img"
              alt={heroPhoto.title}
              sizes={heroPhoto.sizes}
            />
          )
        }
      </Media>
      <div className="blog-post-card-content container-fluid">
        <div className="text-muted">
          {date} - {timeToRead} {props.timeToRead}
        </div>
        <div className="blog-post-card-title">{blogPost.title}</div>
        <div className="blog-post-card-excerpt">{excerpt}</div>
      </div>
    </div>
  );
};

BlogPostCard.propTypes = {
  blogPost: PropTypes.object.isRequired,
  timeToRead: PropTypes.string,
};

export default BlogPostCard;



// WEBPACK FOOTER //
// ./src/components/Main/blog/BlogPostCard.js